export const getScoreColor = (hex: string, score: number): string => {
    const s = Math.max(0, Math.min(100, score));
    const ratio = 1 - s / 100;
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    const newR = Math.round(r + (255 - r) * ratio);
    const newG = Math.round(g + (255 - g) * ratio);
    const newB = Math.round(b + (255 - b) * ratio);
    return (
      "#" +
      newR.toString(16).padStart(2, "0") +
      newG.toString(16).padStart(2, "0") +
      newB.toString(16).padStart(2, "0")
    );
  };
  
  export const getRelevanceColor = (relevance: number) => {
    if (relevance <= 1) return "#D95A51";
    if (relevance <= 3) return "#EF6C00";
    return "#3D8E1D";
  };
  
  export const getBackgroundColor = (relevance: number) => {
    const color = getRelevanceColor(relevance);
    return `${color}1A`;
  };